var e = { relative: {
	now: "now",
	justNow: "just now",
	today: "Today",
	yesterday: "Yesterday",
	expired: "Expired",
	minutesAgoShort: "{{count}}m ago",
	hoursAgoShort: "{{count}}h ago",
	daysAgoShort: "{{count}}d ago",
	monthsAgoShort: "{{count}}mo ago",
	minutesCompact: "{{count}}m",
	hoursCompact: "{{count}}h",
	daysCompact: "{{count}}d",
	weeksCompact: "{{count}}w",
	minutesAgo_one: "{{count}} minute ago",
	minutesAgo_other: "{{count}} minutes ago",
	hoursAgo_one: "{{count}} hour ago",
	hoursAgo_other: "{{count}} hours ago",
	daysAgo_one: "{{count}} day ago",
	daysAgo_other: "{{count}} days ago",
	monthsAgo_one: "{{count}} month ago",
	monthsAgo_other: "{{count}} months ago"
} };
//#endregion
export { e as default };
